















































import { Component, Vue } from 'vue-property-decorator'
import { getUser } from '@/utils/cookies'
@Component({
  name: 'Dashboard'
})
export default class extends Vue {
  private userInfo = {}
  // 挂载结束
  mounted() {
    // 获取用户信息
    const users:any = getUser()
    this.userInfo = JSON.parse(users.toString())
  }
}
